<template>
  <div class="w-full text-sm">
    <span class="block mb-1 text-sm font-semibold tracking-wide text-gray-900" v-if="label">
      {{ label }}
      <span v-if="required" class="text-coral-500">*</span>
    </span>

    <div class="relative flex flex-row items-center">
      <input
        v-bind="$attrs"
        :disabled="disabled || (internalLock && internalDisabled)"
        :value="value"
        @focus="onFocusHandler"
        @blur="onBlurHandler"
        class="form-control focus:border-gray-600"
        :class="[label ? 'mt-1' : '', lock ? 'rounded-none' : '']"
        v-on="inputListeners"
      />
      <div
        v-if="unit"
        class="absolute top-0 right-0 flex items-center justify-center h-full pt-1 pr-2 text-gray-700 select-none"
      >
        <span>{{ unit }}</span>
      </div>

      <div v-if="lock" class="w-4">
        <button
          class="px-2 py-2 bg-gray-100 border-t border-b border-r border-gray-300 outline-none text-lagon-500 focus:outline-none"
          @click="$emit('update:disabled', !disabled)"
        >
          <div class="w-full h-full">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" viewBox="0 0 24 24" v-if="disabled">
              <path
                d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z"
              />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" viewBox="0 0 24 24" v-else>
              <path
                d="M12 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v3h2v-3c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-4v14h18v-14h-12z"
              />
            </svg>
          </div>
          <!-- <font-awesome-icon icon="lock" v-if="disabled"></font-awesome-icon>
          <font-awesome-icon icon="lock-open" v-else></font-awesome-icon> -->
        </button>
      </div>
      <div v-else-if="internalLock">
        <button
          class="px-2 py-2 mt-1 bg-gray-100 border-t border-b border-r border-gray-300 outline-none text-lagon-500 focus:outline-none"
          @click="internalDisabled = !internalDisabled"
        >
          <div class="w-full h-full">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" viewBox="0 0 24 24" v-if="internalDisabled">
              <path
                d="M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z"
              />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" viewBox="0 0 24 24" v-else>
              <path
                d="M12 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v3h2v-3c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-4v14h18v-14h-12z"
              />
            </svg>
          </div>
          <!-- <font-awesome-icon icon="lock" v-if="disabled"></font-awesome-icon>
          <font-awesome-icon icon="lock-open" v-else></font-awesome-icon> -->
        </button>
      </div>
    </div>
    <span class="pt-1 text-xs text-gray-500" v-if="description">{{ description }}</span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    unit: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    lock: {
      type: Boolean,
      default: false,
    },
    internalLock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialValue: this.value,
      internalDisabled: true,
    }
  },
  computed: {
    inputListeners() {
      var vm = this
      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit('input', event.target.value)
        },
      })
    },
  },
  methods: {
    onFocusHandler(e) {
      this.initialValue = this.value
      if (this.value === 0 || this.value === '0') {
        this.$emit('input', null)
      }
    },
    onBlurHandler(e) {
      if ((this.initialValue === 0 || this.initialValue === '0') && !this.value) {
        this.$emit('input', 0)
      }
    },
  },
}
</script>

<style scoped></style>
